import { Tooltip } from "@mui/material";
import "./RolesCell.scss";

export const RolesCell = (cellValues: any) => {
  if (cellValues && cellValues.row && cellValues.row.roles) {
    let rolesStr = cellValues.row.roles
      .map((x: { name: any }) => x.name)
      .join(", ");
    return (
      <Tooltip arrow title={rolesStr}>
        <div className="roles-cell">{rolesStr}</div>
      </Tooltip>
    );
  } else {
    return <></>;
  }
};

export const emailCell = (cellValues: any) => {
  return (
    <Tooltip arrow title={cellValues.row.emailId}>
      <div>{cellValues.row.emailId}</div>
    </Tooltip>
  );
};

export default RolesCell;
